var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6876",
    "data-name": "Group 6876",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1047",
    "data-name": "Ellipse 1047",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#ffe2cf"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_995",
    "data-name": "Ellipse 995",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_20",
    "data-name": "Mask Group 20",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6753",
    "data-name": "Group 6753",
    transform: "translate(11.16 5.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15998",
    "data-name": "Path 15998",
    d: "M69.691,59.508V57.7a5.127,5.127,0,1,0-10.254,0v1.791Z",
    transform: "translate(-43.062 -52.574)",
    fill: "#002f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15999",
    "data-name": "Path 15999",
    d: "M72.583,86.474l-3.351,49H57.186l-.417-49.681Z",
    transform: "translate(-43.668 -45.025)",
    fill: "#002f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16000",
    "data-name": "Path 16000",
    d: "M62.117,133.4,63.43,94.78",
    transform: "translate(-42.453 -42.984)",
    fill: "none",
    stroke: "#2d4574",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16001",
    "data-name": "Path 16001",
    d: "M62.809,91.792h.247a1.351,1.351,0,0,0,1.359-1.359V87.947H62.809Z",
    transform: "translate(-42.296 -44.536)",
    fill: "none",
    stroke: "#2d4574",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16002",
    "data-name": "Path 16002",
    d: "M55.775,90.5a2.857,2.857,0,0,0,2.872,2.826H71.573a2.758,2.758,0,0,0,1.421-.386,2.793,2.793,0,0,0,1.374-2.178l-.2-22.192a15.92,15.92,0,0,0-6.27-3.475H63.141c-.973,0-7.1,2.409-8.725,4.8Z",
    transform: "translate(-44.203 -49.729)",
    fill: "#4666a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16003",
    "data-name": "Path 16003",
    d: "M68.8,77.276l2.286,9.343-.046-7.335Z",
    transform: "translate(-40.935 -46.961)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16004",
    "data-name": "Path 16004",
    d: "M63.35,66.328V93.059",
    transform: "translate(-42.173 -49.448)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16005",
    "data-name": "Path 16005",
    d: "M62.571,69.74a.278.278,0,1,1,.278-.278A.278.278,0,0,1,62.571,69.74Z",
    transform: "translate(-42.413 -48.799)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16006",
    "data-name": "Path 16006",
    d: "M62.571,72.949a.278.278,0,1,1,.278-.278A.278.278,0,0,1,62.571,72.949Z",
    transform: "translate(-42.413 -48.07)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16007",
    "data-name": "Path 16007",
    d: "M62.571,76.171a.278.278,0,1,1,.278-.278A.278.278,0,0,1,62.571,76.171Z",
    transform: "translate(-42.413 -47.338)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16008",
    "data-name": "Path 16008",
    d: "M62.571,79.379a.278.278,0,1,1,.278-.278A.278.278,0,0,1,62.571,79.379Z",
    transform: "translate(-42.413 -46.609)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16009",
    "data-name": "Path 16009",
    d: "M62.571,82.6a.278.278,0,1,1,.278-.278A.278.278,0,0,1,62.571,82.6Z",
    transform: "translate(-42.413 -45.877)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16010",
    "data-name": "Path 16010",
    d: "M62.571,85.822a.278.278,0,1,1,.278-.278A.278.278,0,0,1,62.571,85.822Z",
    transform: "translate(-42.413 -45.145)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16011",
    "data-name": "Path 16011",
    d: "M50.892,84.083H69.269v12.2H50.892Z",
    transform: "translate(-45.004 -45.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16012",
    "data-name": "Path 16012",
    d: "M59.2,93.015l-4.247.093-1.22-1.714,3.289-1.56s1,1.081,1.513,1.513,3.042.664,3.042.664S61.4,93.185,59.2,93.015Z",
    transform: "translate(-44.357 -44.107)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16013",
    "data-name": "Path 16013",
    d: "M58.977,92.6l.8,1a1.6,1.6,0,0,0,.8.525l1.544.417a.582.582,0,0,1-.2,1.143s-2.069-.154-2.749-.278a6.463,6.463,0,0,1-4.448-2.7l3.691-1.035Z",
    transform: "translate(-44.132 -43.69)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16014",
    "data-name": "Path 16014",
    d: "M46.917,85.279l7.83,12.03.494.757,5.56-3.552-.355-.726L54.886,82.5l7.969-9.019-6.347-4.648L47.4,79.163A5,5,0,0,0,46.917,85.279Z",
    transform: "translate(-46.094 -48.879)",
    fill: "#4666a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16015",
    "data-name": "Path 16015",
    d: "M61.5,58.714v7.83l2.27,1.514,2.5-1.514v-7.83Z",
    transform: "translate(-42.593 -51.178)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16016",
    "data-name": "Path 16016",
    d: "M61.513,62.15a4.927,4.927,0,0,0,4.756,1.359V60.992c-.88.015-1.606.077-1.606.077Z",
    transform: "translate(-42.59 -50.661)",
    fill: "#b6662d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16017",
    "data-name": "Path 16017",
    d: "M64.539,64.363a4.787,4.787,0,1,1,4.787-4.787A4.787,4.787,0,0,1,64.539,64.363Z",
    transform: "translate(-42.991 -52.07)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16018",
    "data-name": "Path 16018",
    d: "M68.762,59.595l.432-.973s-.17-.819-.9-3.984C68.315,54.637,65.01,57.865,68.762,59.595Zm-8.478,0-.432-.973s.17-.819.9-3.984C60.748,54.637,64.037,57.865,60.284,59.595Z",
    transform: "translate(-42.968 -52.105)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16019",
    "data-name": "Path 16019",
    d: "M60.161,59.43a1.224,1.224,0,1,1,1.328-1.22A1.277,1.277,0,0,1,60.161,59.43Z",
    transform: "translate(-43.199 -51.57)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16020",
    "data-name": "Path 16020",
    d: "M60.078,57.33a.836.836,0,0,0-.88.8.747.747,0,0,0,.247.556",
    transform: "translate(-43.117 -51.493)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16021",
    "data-name": "Path 16021",
    d: "M67.661,59.43a1.224,1.224,0,1,1,1.328-1.22A1.277,1.277,0,0,1,67.661,59.43Z",
    transform: "translate(-41.495 -51.57)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16022",
    "data-name": "Path 16022",
    d: "M67.415,57.33a.836.836,0,0,1,.88.8.747.747,0,0,1-.247.556",
    transform: "translate(-41.249 -51.493)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16023",
    "data-name": "Path 16023",
    d: "M67.674,55.91l.463-1.174a14.054,14.054,0,0,0-7.567,0l.911,2.054C61.5,56.79,67.179,57.254,67.674,55.91Z",
    transform: "translate(-42.805 -52.204)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16024",
    "data-name": "Path 16024",
    d: "M65.852,64.314l-2.5,2.471,1.714,1.529,1.189-2.95Z",
    transform: "translate(-42.173 -49.906)",
    fill: "#002f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16025",
    "data-name": "Path 16025",
    d: "M63.871,66.782l-2.255-2.456-.556,1.05,1.081,3.073Z",
    transform: "translate(-42.693 -49.903)",
    fill: "#002f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16026",
    "data-name": "Path 16026",
    d: "M60.656,73.664h-3.8",
    transform: "translate(-43.648 -47.781)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16027",
    "data-name": "Path 16027",
    d: "M53.145,92.691l.479.741,5.56-3.552-.355-.726Z",
    transform: "translate(-44.492 -44.262)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16028",
    "data-name": "Path 16028",
    d: "M53.246,81l1.946-5.621.216,3.166Z",
    transform: "translate(-44.469 -47.393)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16029",
    "data-name": "Path 16029",
    d: "M67.122,91.826l4.247.093,1.22-1.714L69.3,88.645s-1,1.081-1.513,1.513-3.042.664-3.042.664S64.929,92,67.122,91.826Z",
    transform: "translate(-41.856 -44.378)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16030",
    "data-name": "Path 16030",
    d: "M67.345,91.408l-.8,1a1.6,1.6,0,0,1-.8.525l-1.544.417a.582.582,0,0,0,.2,1.143s2.069-.154,2.749-.278a6.463,6.463,0,0,0,4.448-2.7L67.9,90.482Z",
    transform: "translate(-42.08 -43.96)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16031",
    "data-name": "Path 16031",
    d: "M81.059,84.089l-7.83,12.03-.494.757-5.56-3.552.355-.726,5.56-11.289-7.969-9.019,6.347-4.648L80.58,77.974A5,5,0,0,1,81.059,84.089Z",
    transform: "translate(-41.771 -49.15)",
    fill: "#4666a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16032",
    "data-name": "Path 16032",
    d: "M72.846,91.5l-.479.741-5.559-3.552.355-.726Z",
    transform: "translate(-41.387 -44.532)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16033",
    "data-name": "Path 16033",
    d: "M72.027,79.807l-1.946-5.621-.216,3.166Z",
    transform: "translate(-40.693 -47.663)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16034",
    "data-name": "Path 16034",
    d: "M68.439,55.267s-2.9,1.961-7.907.757L60.053,57.8l.124-2.888,3.953-1.482,4.185,1.452Z",
    transform: "translate(-42.922 -52.379)",
    fill: "#002f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16035",
    "data-name": "Path 16035",
    d: "M64.43,60.659a1.482,1.482,0,0,1-1.683-.649",
    transform: "translate(-42.31 -50.884)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.1eaf5d01de82f64bc3e2d8b72d84c789.svg";
export { ForwardRef as ReactComponent };